<template>
  <img class="base-image-circle-image" :src="computedSrc" :alt="alt" />
</template>

<script>
import DefaultAvatar from '@/assets/img/default_avatar.svg';

export default {
  name: 'BaseAvatarIcon',
  props: {
    src: {
      type: String,
      required: false,
      default: () => DefaultAvatar,
    },
    alt: {
      type: String,
      required: true,
    },
  },
  computed: {
    computedSrc() {
      return this.src ? this.src : DefaultAvatar;
    },
  },
};
</script>

<style scoped lang="scss">
.base-image-circle-image {
  object-fit: cover;
  border-radius: 50%;
}
</style>
